(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleExclusionsController', MonitoringRuleExclusionsController);

    MonitoringRuleExclusionsController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', 'AlertService', 'MonitoringRule', 'MonitoringRuleTemporaryExclusion'];

    function MonitoringRuleExclusionsController($scope, $state, $stateParams, $uibModal, AlertService, MonitoringRule, MonitoringRuleTemporaryExclusion) {
        var vm = this;
        vm.monitoringRule = {};
        vm.exclusions = [];
        vm.loadAll = loadAll;
        vm.openDialog = openDialog;
        vm.delete = remove;

        MonitoringRule.get({ id: $stateParams.id }, function(result) {
            vm.monitoringRule = result;
        });

        vm.loadAll();

        function loadAll() {
            MonitoringRuleTemporaryExclusion.query({ monitoringRuleId: $stateParams.id }, function(result) {
                vm.exclusions = result;
            }, onError);
        }

        function openDialog(entity) {
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-exclusion-dialog.html',
                controller: 'MonitoringRuleExclusionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        if (entity) {
                            return angular.copy(entity);
                        }
                        return {
                            id: null,
                            monitoringRuleId: parseInt($stateParams.id, 10),
                            validiteMois: 1
                        };
                    },
                    historyContext: function() {
                        return null;
                    }
                }
            }).result.then(function() {
                loadAll();
            });
        }

        function remove(id) {
            if (!window.confirm('Supprimer cette exclusion temporaire ?')) {
                return;
            }
            MonitoringRuleTemporaryExclusion.delete({ id: id }, function() {
                loadAll();
            }, onError);
        }

        function onError(error) {
            AlertService.error(error && error.data ? error.data.message : 'Erreur');
        }
    }
})();
